// extracted by mini-css-extract-plugin
module.exports = {"plus":"DetailsInputButtonInBasket_plus__-I9hy","minus":"DetailsInputButtonInBasket_minus__2wyI2"};